var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCaretLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "12 10 6 10"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M16.464 19.85a.465.465 0 0 0 .683 0l.684-.716a.52.52 0 0 0 0-.714l-3.295-3.405 3.322-3.433c.19-.2.19-.52 0-.717l-.683-.717a.47.47 0 0 0-.684 0l-4.35 4.508a.526.526 0 0 0 0 .717z"
})));
export default SvgCaretLeft;